// @flow

/**
 * Functionality to mask current user as another user
 * @module
 */

/** Reference ID for value */
const STORAGE_ID: 'RACHIO/MASK_AS_USER_ID' = 'RACHIO/MASK_AS_USER_ID'

const fallbackStorage = {
  _data: {},
  setItem: function(id, val) {
    return (this._data[id] = String(val))
  },
  getItem: function(id) {
    return this._data.hasOwnProperty(id) ? this._data[id] : undefined
  },
  removeItem: function(id) {
    return delete this._data[id]
  },
  clear: function() {
    return (this._data = {})
  }
}

/** Storage mechanism */
const storage = window.localStorage || fallbackStorage

/**
 * Set `maskAsUserId`
 * @param {string} [id] - User ID set it to, null to clear
 */
export const setMaskAsUserId = (id?: ?string): void => {
  if (id) {
    storage.setItem(STORAGE_ID, id)
  } else {
    storage.removeItem(STORAGE_ID)
  }
}

/**
 * Get `maskAsUserId`
 * @return {string} - Current `maskAsUserId` value
 */
export const getMaskAsUserId = (): ?string => storage.getItem(STORAGE_ID)

/**
 * Given a userId, return `maskAsUserId` if it has a value, otherwise return the passed in userId
 * @param  {string} userId - Given userId
 * @return {string} - `maskAsUserId` or passed in `userId`
 */
export const getResolvedUserId = (userId: string) => getMaskAsUserId() || userId
